import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref, watch } from 'vue';
import { type WorkOrder } from '@newmoon-org/types';

import WorkOrderService from '@/service/workorders.service';


export default /*#__PURE__*/_defineComponent({
  __name: 'WarrantyPossible',
  props: {
    jobSiteId: null,
    value: null
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  jobSiteId?: string;
  value?: {
    project: string;
    company: string;
    workOrderId: string;
    workOrderNumber: string;
  };
}



let workOrders: WorkOrder[];

const warrantyPossible = ref<boolean>(false);
const loadingJobSiteWorkOrders = ref<boolean>(false);
const showError = ref<boolean>(false);
const showNoCompaniesMessage = ref<boolean>(false);
const selectedCompany = ref<string | null>(null);
const selectedProject = ref<string | null>(null);
const selectedWorkOrderId = ref<string | null>(null);

const companies = ref<Set<string>>();
const projects = ref<Set<string>>();
const filteredWorkOrders = ref<Set<WorkOrder>>();

onMounted(async () => {
  if (!props.value) return;
  const { company, project, workOrderId } = props.value;
  if (company || project || workOrderId) {
    warrantyPossible.value = true;
  }
  await loadWorkOrders();

  selectedWorkOrderId.value = workOrderId;
  selectedProject.value = project;
  selectedCompany.value = company;
});

watch(() => props.jobSiteId, clearValues);

watch([warrantyPossible, () => props.jobSiteId], async () => {
  if (!warrantyPossible.value) {
    clearValues();
    return;
  }
  if (!props.jobSiteId) {
    showError.value = true;
    return;
  }
  showError.value = false;
  showNoCompaniesMessage.value = false;

  if (!workOrders) await loadWorkOrders();

  companies.value = new Set(workOrders.map<string>(wo => wo.company));
  if (!companies.value?.size) showNoCompaniesMessage.value = true;
});

watch(selectedCompany, () => {
  if (!selectedCompany.value || !workOrders) return;
  projects.value = new Set(
    workOrders
      .filter(wo => wo.company === selectedCompany.value)
      .map(wo => (wo.techProjectId ? wo.techProjectId : wo.project?.code))
      .filter((code): code is string => !!code)
  );
  emitUpdate();
});

watch(selectedProject, () => {
  if (!selectedProject.value || !workOrders) return;
  filteredWorkOrders.value = new Set(
    workOrders.filter(wo => {
      const code = wo.techProjectId ? wo.techProjectId : wo.project?.code;
      return wo.company === selectedCompany.value && code === selectedProject.value;
    })
  );
  emitUpdate();
});

watch(selectedWorkOrderId, () => emitUpdate());

function clearValues() {
  selectedProject.value = null;
  selectedCompany.value = null;
  selectedWorkOrderId.value = null;
  emitUpdate();
}
function emitUpdate() {
  emit('input', {
    company: selectedCompany.value,
    project: selectedProject.value,
    workOrderId: selectedWorkOrderId.value,
    workOrderNumber: getWorkOrderNumberById(selectedWorkOrderId.value),
  });
}

function getWorkOrderNumberById(id: string | null): string | null {
  if (!id) return null;
  const wo = workOrders.find(wo => wo.id === id);
  return wo?.workOrderNumber ?? null;
}

async function loadWorkOrders() {
  if (!props.jobSiteId || !warrantyPossible.value) return;
  loadingJobSiteWorkOrders.value = true;
  workOrders = (await WorkOrderService.getWorkOrdersByJobSite(props.jobSiteId)) as unknown as WorkOrder[];
  loadingJobSiteWorkOrders.value = false;
}

return { __sfc: true,props, emit, workOrders, warrantyPossible, loadingJobSiteWorkOrders, showError, showNoCompaniesMessage, selectedCompany, selectedProject, selectedWorkOrderId, companies, projects, filteredWorkOrders, clearValues, emitUpdate, getWorkOrderNumberById, loadWorkOrders }
}

})